import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../icon';
import './style.scss';

export default class Button extends React.Component {

	static propTypes = {
		className: PropTypes.string,
		icon: PropTypes.any,
		set: PropTypes.string,
		label: PropTypes.any,
		badge: PropTypes.string,
		onClick: PropTypes.func,
		getRef: PropTypes.func,
		disabled: PropTypes.bool,
		type: PropTypes.oneOf(['button', 'submit', 'link']),
	};

	static defaultProps = {
		className: 'btn-default',
		icon: null,
		disabled: false,
		set: 'admin',
		type: 'button',
	};

	clicked = false;

	onMount = el => {
		this.el = el;
		if (this.props.getRef) this.props.getRef(el);
	};

	onClick = async e => {
		if (this.clicked) {
			console.log('awating handler', this.clicked);
			return;
		}
		this.clicked = true;
		if (this.el) this.el.classList.add('btn-clicked');
		if (this.props.onClick) await this.props.onClick(e);
		if (this.el) this.el.classList.remove('btn-clicked');
		this.clicked = false;
	};

	render() {
		let { className, icon, set, label, badge, type, getRef, disabled, children, ...rest } = this.props;

		className = (type !== 'link' ? 'btn ' : 'btn-link-type ') + className;

		if (icon) {
			className += ' with-icon';
		}

		if (!label && !children) {
			className += ' no-label';
		}

		if (disabled) {
			className += ' btn-disabled';
		}

		let inner = <React.Fragment>
			{icon && <span className="btn-icon">{icon}</span>}
			{label}
			{children}
			{badge && <span className="btn-badge">{badge}</span>}
		</React.Fragment>;

		if (rest.href) {
			if (this.props.onClick) rest.onClick = this.onClick; // если задан onClick, игнорируем href
			return <a className={className} ref={this.onMount} {...rest}>{inner}</a>;
		}
		else {
			if (type === 'link') {
				rest.href = '#';
				rest.onClick = e => {
					e.preventDefault();
					this.onClick();
				};
				return <a className={className} ref={this.onMount} {...rest}>{inner}</a>;
			}
			else {
				rest.type = type;
				rest.onClick = this.onClick;
				return <button className={className} ref={this.onMount} disabled={disabled} {...rest}>{inner}</button>;
			}
		}

	}

}
